import { create } from "zustand";

import { ButtonProps } from "@/components/ui/button";

export type GlobalActionButtonConfig = Omit<
  ButtonProps,
  "asChild" | "variant"
> & {
  variant?: string;
  onClick: NonNullable<ButtonProps["onClick"]>;
};

interface GlobalActionButtonStore {
  config: GlobalActionButtonConfig | null;
  setAction: (config: GlobalActionButtonConfig | null) => void;
  clearAction: () => void;
}

export const useGlobalActionButtonStore = create<GlobalActionButtonStore>(
  (set) => ({
    config: null,
    setAction: (config) => set({ config }),
    clearAction: () => set({ config: null }),
  }),
);
